import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

let echoInstance = null;

const connect = () => {
  if (echoInstance) return echoInstance;

  window.Pusher = Pusher;

  echoInstance = new Echo({
    broadcaster: 'pusher',
    key: process.env.VUE_APP_PUSHER_APP_KEY,
    cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
    forceTLS: true,
  });

  return echoInstance;
};

const disconnect = () => {
  if (echoInstance) {
    echoInstance.disconnect();
    echoInstance = null;
  }
};

export { connect, disconnect };
